import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  setActiveItem,
  setActiveItemWithoutSideBar,
  selectIsActive,
  type ToolbarItemState,
} from '../slice'
import { useLocation } from 'react-router-dom'

export const useIsItemActive = (
  id?: string,
  link?: string,
  hasSideBar: boolean = false,
) => {
  const location = useLocation()
  const isActive = useSelector((state: { toolbarItem: ToolbarItemState }) =>
    id ? selectIsActive(state, id) : false,
  )
  const isUrlActive = link && location.pathname === link

  const isItemActive = isUrlActive || isActive

  const dispatch = useDispatch()
  useEffect(() => {
    if (isUrlActive && id) {
      dispatch(hasSideBar ? setActiveItem(id) : setActiveItemWithoutSideBar(id))
    }
  }, [isUrlActive, dispatch, id, hasSideBar])

  return { isItemActive }
}
